import { POLICY_VERSION, SCHEMA_VERSION } from './constants';

export const CONSENT_RECEIPT_URL = `${import.meta.env.VITE_AUTH_DOMAIN || ''}/api/v1/consent/receipt/`;

/**
 * Records a consent event server-side for GDPR Art 7(1) accountability.
 *
 * Strictly best-effort and deliberately fire-and-forget. The cookie written by
 * consentStore is authoritative for gating; this receipt is evidence only. If
 * the API is unreachable the visitor's choice still applies — an audit-log
 * outage must never block someone from exercising a privacy choice.
 *
 * `sendBeacon` is used so the request survives the page reload that follows a
 * withdrawal. It is queued by the browser and not cancelled on unload.
 */
export function recordConsentReceipt({ state, action, transport = defaultTransport }) {
  if (!state?.consentId) {
    return false;
  }

  const payload = {
    consent_id: state.consentId,
    action,
    categories: state.categories,
    policy_version: POLICY_VERSION,
    schema_version: SCHEMA_VERSION,
  };

  try {
    return transport(CONSENT_RECEIPT_URL, JSON.stringify(payload));
  }
  catch {
    // Never let receipt logging surface to the user or block the gate.
    return false;
  }
}

function defaultTransport(url, body) {
  if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
    return navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
  }

  if (typeof fetch === 'function') {
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
    return true;
  }

  return false;
}
